import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

interface SaleDialogFooterProps {
  onCancel: () => void;
  onConfirm: () => void;
  isDisabled: boolean;
  isCredit: boolean;
}

export const SaleDialogFooter = ({
  onCancel,
  onConfirm,
  isDisabled,
  isCredit,
}: SaleDialogFooterProps) => {
  return (
    <DialogFooter>
      <Button variant="outline" onClick={onCancel}>
        Annuler
      </Button>
      <Button 
        onClick={onConfirm}
        disabled={isDisabled}
      >
        {isCredit ? "Confirmer la vente à crédit" : "Confirmer la vente"}
      </Button>
    </DialogFooter>
  );
};